import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M21 12.9H3V11.1H21V12.9ZM21 7.5H3V9.3H21V7.5ZM21 14.7H8.4V16.5H21V14.7Z' />
        </SvgIcon>
    );
});
